import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/observable/fromPromise';

/**
 * Cache-buster stamped once per app load. The i18n JSON assets are not
 * fingerprinted, so without this the browser/CDN keeps serving a cached copy
 * after a deploy and newly added keys (e.g. "Order.AltSize") render as the raw
 * key. Computed once at module load so translation fetches stay cached within a
 * session but always refresh on the next page load / deploy.
 */
const TRANSLATIONS_CACHE_BUSTER = Date.now();

/**
 * Load multiple json files in assets/i18n folder. Work for multiple languages support.
 */
export class MultiTranslateHttpLoader implements TranslateLoader {
    constructor(private http: HttpClient,
                public resources: { prefix: string, suffix: string }[] = [{
                  prefix: './assets/i18n/core/',
                  suffix: '.json'
                }]) {}

    public getTranslation(lang: string): any {
      return Observable.forkJoin(this.resources.map(config => {
        return this.http.get(`${config.prefix}${lang}${config.suffix}?v=${TRANSLATIONS_CACHE_BUSTER}`);
      })).map(response => {
        return response.reduce((a, b) => {
          return Object.assign(a, b);
        });
      });
    }

    /*
    public getTranslation(lang: string): any {
        return Observable.forkJoin(this.resources.map(config => {
          return Observable.fromPromise(System.import(`${config.prefix}${lang}${config.suffix}`)) ;
        })).map(response => {
          return response.reduce((a, b) => {
            return Object.assign(a, b);
          });
        });
      }
      */
  }
